module.exports = __webpack_public_path__ + "static/img/7areaA_03.b943a60.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/animal/7areaA_03.png
// module id = 817
// module chunks = 1